import React, { useEffect,useState } from 'react'
import { Button, Col, Divider, Row,Space } from 'antd';
import { PlusOutlined,PoweroffOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import ZonesIndexTable from '../../components/zonesTable';

const { Title } = Typography;
const ZoneIndex = (props) => {
  console.log(props.zones)
  const [success, setSuccess] = useState(false)
  useEffect(() => {
   
  },[])
  return (
  <>
   <Row>
    <Col span={21}>
      <Title level={3}>Zones Overview</Title>
    </Col>
    <Col span={3}>
      <Button icon={<PlusOutlined />} style={{marginTop: 20}} href='/admin/zones/new' type="primary"level={3}>Create Zone</Button>
    </Col>
    </Row>
    <Divider />
  <Row>
    <Col push={4} span={16}>
      </Col>
  </Row>
  <Row>
    <Col span={18} push={4}>
       <ZonesIndexTable zones={props.zones}/>
     {/* {success ? <Notification message={"Client Successfully Created"} messageType='success' icon='success' />:null} */}
    </Col>
  </Row>
  </>
  )
};
export default ZoneIndex;